// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"d48d424c","306":"0c7b7740","510":"d32ea9af","532":"5d751a18","629":"c639b767","765":"58a55a31","852":"d48d424c","871":"68229773","949":"d48d424c"}[chunkId] + ".chunk.css";
};